import { render, staticRenderFns } from "./corporateOwnerForm.vue?vue&type=template&id=7d2d05e8&scoped=true&lang=en&"
import script from "./corporateOwnerForm.vue?vue&type=script&lang=js&"
export * from "./corporateOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./corporateOwnerForm.vue?vue&type=style&index=0&id=7d2d05e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2d05e8",
  null
  
)

export default component.exports